import { render, staticRenderFns } from "./CustomerFieldServerTable.vue?vue&type=template&id=a1312c54"
import script from "./CustomerFieldServerTable.vue?vue&type=script&lang=js"
export * from "./CustomerFieldServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports